module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_5.2f962c10.png";